import React from 'react';

import { useSuggestions } from '@helpers/hooks/pages/dashboard/ideasChannel/useSuggestions';
import { friendlyNumberFormatter } from '@helpers/masks';
import { IVoteProps } from '@domain/interfaces/dashboard/IdeasChannel/suggestions';

import * as S from './styles';

const Vote: React.FC<IVoteProps> = ({ suggestions }) => {
  const { voteUp, voteDown } = useSuggestions();

  const votesNumber = suggestions.votes_up;
  const ideaAliasId = suggestions.id;
  const isVoted = suggestions.is_voted_up_by_user;

  const [isUpvoted, setIsUpvoted] = React.useState<boolean>(false);
  const [votes, setVotes] = React.useState<number>(0);

  const formattedVotesNumber = friendlyNumberFormatter(votes, 1, true);

  const handleClick = React.useCallback(() => {
    if (isUpvoted) {
      voteDown({ ideaAliasId });
      setVotes(state => state - 1);
    }

    if (!isUpvoted) {
      voteUp({ ideaAliasId });
      setVotes(state => state + 1);
    }

    setIsUpvoted(!isUpvoted);
  }, [isUpvoted, voteDown, voteUp, ideaAliasId]);

  React.useEffect(() => {
    setIsUpvoted(isVoted);
  }, [isVoted]);

  React.useEffect(() => {
    setVotes(votesNumber);
  }, [votesNumber]);

  return (
    <S.VoteWrapper onClick={handleClick} isVoted={isUpvoted}>
      <S.ArrowUp />
      <S.VotesCount>{formattedVotesNumber}</S.VotesCount>
    </S.VoteWrapper>
  );
};

export default Vote;
